import React from 'react'

import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'
import { LogoIcon } from '@/shared/components/atoms/Logo'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogTitle,
} from '@/shared/components/molecules/Dialog/dialog'

interface ZoneOnboardingSuccessModalProps {
	visible: boolean
	onClose: () => void
}

const ZoneOnboardingSuccessModal: React.FC<ZoneOnboardingSuccessModalProps> = ({
	visible,
	onClose,
}) => {
	const { t } = useTranslation('zones')

	return (
		<Dialog open={visible} onOpenChange={onClose}>
			<DialogContent
				showCloseButton={false}
				className="bg-[#1a1a1a] border-gray-800 max-w-sm"
				onInteractOutside={(e) => e.preventDefault()}
				onEscapeKeyDown={(e) => e.preventDefault()}
			>
				<div className="flex flex-col items-center space-y-6 py-4">
					{/* Brandtrack Logo */}
					<LogoIcon width="64px" height="64px" />

					{/* Title and Description */}
					<div className="space-y-3 text-center">
						<DialogTitle className="text-white text-2xl font-bold">
							{t('modals.zoneOnboarding.success.title')}
						</DialogTitle>
						<DialogDescription className="text-gray-400 text-base leading-relaxed whitespace-pre-line">
							{t('modals.zoneOnboarding.success.description')}
						</DialogDescription>
					</div>

					{/* Action Button */}
					<Button
						onClick={onClose}
						className="w-full h-12 text-base font-medium rounded-full bg-white text-black hover:bg-gray-200"
					>
						{t('modals.zoneOnboarding.success.button')}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	)
}

export default ZoneOnboardingSuccessModal
